/** @typedef {{
 *     onShow: (JQLite, any) => void,
 *     onShown: (JQLite, any) => void,
 *     onHide: (JQLite, any) => void,
 *     onHidden: (JQLite, any) => void,
 *     options: string,
 *     modal: string
 * }} ModalOptions */

var Modal = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */

    const defaultModalOptions = {
        onShow: function () { },
        onShown: function () { },
        onHide: function () { },
        onHidden: function () { },
        options: "show",
        modal: '#FD_MODAL'
    };
    let modalLock = false;

    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    /**
     * @callback AjaxCallback
     * @param {any} result
     * @param {JQLite} $modal
     */

    /**
     * @param {string} html
     * @param {ModalOptions} modalOptions
     * @param {any} result The ajax result object that led to showing the modal
     * @param {AjaxCallback} callbackBeforeShow The callback to execute before showing the modal
     * @param {boolean} forceOpen If another modal is open and this is set to true, this modal will open anyway.
     * @returns {JQLite}
     */
    function showModal(html, modalOptions, result, callbackBeforeShow, forceOpen) {
        let locked = modalLock;
        if (locked && !forceOpen) {
            return null;
        }
        modalLock = true;
        modalOptions = $.extend({}, defaultModalOptions, modalOptions);

        /** @type JQLite */
        const $modal = $(modalOptions.modal)
            .html(html)
            .enableControls()
            .on('show.bs.modal', function () {
                if (modalOptions.onShow) {
                    modalOptions.onShow($modal, result);
                }
                $modal.off('show.bs.modal');
            })
            .on('shown.bs.modal', function () {
                if ($(".modal:visible").length > 1) {
                    $(".modal:visible").not($modal).addClass('modal-disabled');
                }
                $('[data-fd-control="textarea"]', $modal).control_textarea('resize');
                $('[autofocus]', $modal).focus();

                if (modalOptions.onShown) {
                    modalOptions.onShown($modal, result);
                }
                $modal.off('shown.bs.modal');
            })
            .on('hide.bs.modal', function () {
                $('form', $modal).dirtyForms('setClean');

                if (modalOptions.onHide) {
                    modalOptions.onHide($modal, result);
                }
                $modal.off('hide.bs.modal');
            })
            .on('hidden.bs.modal', function () {
                if ($(".modal:visible").length > 0) {
                    $(".modal:visible").not($modal).last().removeClass('modal-disabled');
                    $('body').addClass('modal-open');
                } else {
                    modalLock = false; // release lock before onHidden in order to open another modal on callback if wanted
                }
                if (modalOptions.onHidden) {
                    modalOptions.onHidden($modal, result);
                }
                $modal.off('hidden.bs.modal');
            });

        if (callbackBeforeShow) {
            callbackBeforeShow(result, $modal);
        }

        if (locked && !forceOpen) {
            return $modal;
        }

        return modalOptions.options ? $modal.modal(modalOptions.options) : $modal.modal("show");
    }

    /* ========================================================================
     *  Public Members
     * ========================================================================
    */

    return {
        /**
         * @param {AjaxOptions} ajaxOptions
         * @param {ModalOptions} modalOptions
         * @param {boolean} forceOpen
         */
        fdAjax: function (ajaxOptions, modalOptions, forceOpen) {
            if (modalLock) {
                return;
            }
            modalLock = true;

            const currentCallback = ajaxOptions.callback;
            ajaxOptions.callback = function (result) {
                if (result.data) {
                    modalLock = false;
                    showModal(result.data, modalOptions, result, currentCallback, forceOpen);
                } else {
                    modalLock = false; // release lock before onHidden in order to open another modal on callback if wanted
                    if (currentCallback) {
                        currentCallback(result);
                    }
                }
            };

            $.fdAjax(ajaxOptions);
        },


        /**
         * @param {string} html
         * @param {ModalOptions} modalOptions
         * @param {boolean} forceOpen
         */
        showModal: function (html, modalOptions, forceOpen) {
            return showModal(html, modalOptions, null, null, forceOpen);
        },

        hideModal: function () {
            if (Modal.isOpen()) {
                $(this).closest('.modal').modal('hide');
            }
        },

        isOpen: function isOpen() {
            return modalLock;
        },

        /**
         * @param {{ responseText: string }} xhr
         */
        openModal: function (xhr, modalOptions) {
            FD.Utility.stopLadda.call(this);
            return showModal(typeof xhr == "string" ? xhr : xhr.responseText, typeof (modalOptions) == 'object' ? modalOptions : undefined);
        }
    };
}();